
import React from "react";
import { cn } from "@/lib/utils";
import { ProposalSection } from "../types/proposalSection";
import { Separator } from "@/components/ui/separator";

interface ProposalSidebarProps {
  sections: ProposalSection[];
  activeSection: string;
  onSectionChange: (section: string) => void;
}

export const ProposalSidebar = ({ 
  sections, 
  activeSection, 
  onSectionChange 
}: ProposalSidebarProps) => {
  return (
    <div className="w-full md:w-64 shrink-0">
      <div className="bg-gray-50 rounded-lg p-4 sticky top-4">
        <h2 className="font-medium text-gray-700 mb-4">RFP/Instruction Sections</h2>
        <nav className="flex flex-col space-y-1">
          {sections.map((section, index) => (
            <React.Fragment key={section.slug}>
              <button 
                onClick={() => onSectionChange(section.slug)}
                className={cn(
                  "px-3 py-2 text-sm rounded-md text-left transition-colors flex items-center w-full",
                  activeSection === section.slug 
                    ? "bg-gray-100 text-black font-medium" 
                    : "text-gray-700 hover:bg-gray-100"
                )}
              >
                <section.icon className="h-4 w-4 mr-2" />
                {index + 1}. {section.title}
              </button>
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
};
